import React from 'react'
import * as S from './MenuItems.styles'
import { MenuItem } from '../MenuItem/MenuItem'
import {
  ArtIcon,
  CollageIcon,
  BookIcon,
  ChatIcon,
  GalleryWallsIcon,
  GiftIcon,
  HeartIcon,
  HistoryIcon,
  PercentageMarkIcon,
  PhotoIcon,
  QuestionMarkIcon,
  ReferralIcon,
} from '../../../icons'
import { translateManager as t } from '../../../services/TranslateManager'
import {
  DISCOVERY_URL,
  AI_GENERATION_URL,
  GIFT_CARD,
  JUMBLE_URL_PREFIX,
  MY_ORDERS_URL,
  ONBOARDING_URL,
  COLLAGE_PRODUCT_PAGE,
  PHOTO_STYLER_URL,
  REFERRAL,
  ART_COLLECTION_HOME_URL,
} from '../../../config/config'
import StorageManager from '../../../services/StorageManager'
import { ACTIVE_ORDERS_COUNT_KEY } from '../../../services/LoginUtills'
import { emailCaptureManager } from '../../../services/EmailCaptureManager'
import { MENU_ITEMS } from './MenuItems.consts'
import { QUIZ_STEPS } from '../../../pages/EmailCapturePage/EmailCapturePage.consts'
import { intercomService } from '../../../services/Analytics/platforms/intercom'
import { useExperimentManager } from '../../../services/ExperimentManager/ExperimentManager'
import { getPhotoBookURL } from '../../../services/PhotoBook/photoBookUtils'
import GuarenteeElement from '../QualityGuaranteeElement/QualityGuaranteeElement'
import { getReferralPrice } from '../../../pages/Referral/referralUtils'
import { NavDivider } from '../Divider.styles'
import { useNavigate } from '@remix-run/react'
import { AICreationIcon } from './MenuItems.styles'

let intercomShowCallBackSet = false
let showHelp = false

export default function MenuItems({ onDismissMenu, onPromoCodeClick }) {
  const navigate = useNavigate()
  const experimentManager = useExperimentManager()
  const isQualityGuaranteeEnabled = experimentManager.isEnabled(
    'quality-guarantee-banner'
  )

  const handleTalkToUsClicked = () => {
    intercomService.show()
    onDismissMenu()
  }

  const handleHelpCenterClick = () => {
    // Work around for non-working help center.
    // The workaround is to show the help center in the home space first, then show the help space.
    // should be replaced with intercomService.showSpace('help')
    showHelp = true
    if (!intercomShowCallBackSet) {
      intercomService.setOnShowEvent(() => {
        if (showHelp) {
          showHelp = false
          setTimeout(() => intercomService.showSpace('help'), 500)
        }
      })
      intercomShowCallBackSet = true
    }

    intercomService.show()
    onDismissMenu()
  }

  const questionBeforeRedirect = (e, returnToPath) => {
    if (!emailCaptureManager.passedAnyOnboarding()) {
      // Redirect user to onboarding if they should pass it before continuing to the target url
      e.preventDefault()
      const searchParams = new URLSearchParams({
        redirectTo: returnToPath,
      })
      navigate({
        pathname: `${ONBOARDING_URL}/${QUIZ_STEPS.INTRO}`,
        search: searchParams.toString(),
      })
    }
  }

  const questionBeforeRedirectJumble = (e, returnToPath) => {
    if (!emailCaptureManager.passedJumbleOnboarding()) {
      // Redirect user to onboarding if they should pass it before continuing to the target url
      e.preventDefault()
      const searchParams = new URLSearchParams({
        redirectTo: returnToPath,
      })
      navigate({
        pathname: `${ONBOARDING_URL}/${QUIZ_STEPS.INTRO}`,
        search: searchParams.toString(),
      })
    }
  }

  return (
    <S.Container>
      <S.Section>
        {isQualityGuaranteeEnabled && (
          <S.Item>
            <GuarenteeElement />
          </S.Item>
        )}
        <S.Item>
          <MenuItem
            itemId={MENU_ITEMS.MIXTILES_CLASSIC}
            icon={<PhotoIcon />}
            text={t.get('general.menu.frame_your_photos')}
            location={{ pathname: PHOTO_STYLER_URL }}
            onClick={(e) => questionBeforeRedirect(e, PHOTO_STYLER_URL)}
            testId="frame-your-photos"
          />
        </S.Item>
        {experimentManager.isEnabled('photo-books') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.PHOTO_BOOK}
              icon={<BookIcon />}
              text={t.get('product_selection.photo_books_name')}
              location={{
                pathname: getPhotoBookURL(),
                state: { source: 'Menu' },
              }}
            />
          </S.Item>
        )}
        {experimentManager.isEnabled('jumble') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.JUMBLE}
              icon={<HeartIcon />}
              text="Jumble"
              location={{ pathname: JUMBLE_URL_PREFIX }}
              onClick={(e) =>
                questionBeforeRedirectJumble(e, JUMBLE_URL_PREFIX)
              }
            />
          </S.Item>
        )}
        {experimentManager.isEnabled('gallery-walls') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.GALLERY_WALLS}
              icon={<GalleryWallsIcon />}
              text={t.get('pitch.footer.gallery_walls')}
              location={{ pathname: DISCOVERY_URL, state: { source: 'Menu' } }}
              onClick={(e) => questionBeforeRedirect(e, DISCOVERY_URL)}
            />
          </S.Item>
        )}
        {experimentManager.isEnabled('ai-templates') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.AI_GENERATION}
              icon={<AICreationIcon />}
              text={t.get('ai_templates.menu_title')}
              location={{
                pathname: AI_GENERATION_URL,
                state: { source: 'Menu' },
              }}
              onClick={(e) => questionBeforeRedirect(e, AI_GENERATION_URL)}
            />
          </S.Item>
        )}
        {experimentManager.isEnabled('art-in-plus') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.ART}
              icon={<ArtIcon />}
              text={t.get('general.menu.art_collection')}
              location={{
                pathname: ART_COLLECTION_HOME_URL,
                search: '?arrivedFrom=Classic Menu',
              }}
              testId="browse-art"
            />
          </S.Item>
        )}
        {experimentManager.isEnabled('collage-in-menu') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.COLLAGE}
              icon={<CollageIcon />}
              text={t.get('collage.collage')}
              location={{
                pathname: COLLAGE_PRODUCT_PAGE,
              }}
              testId="browse-collage"
            />
          </S.Item>
        )}
      </S.Section>
      <NavDivider />
      <S.Section>
        <S.Item>
          <MenuItem
            itemId={MENU_ITEMS.GIFT_CARD}
            icon={<GiftIcon />}
            text={t.get('general.menu.buy_gift_card')}
            location={{ pathname: GIFT_CARD }}
            testId="gift-card-menu-item"
          />
        </S.Item>
        <S.Item>
          <MenuItem
            itemId={MENU_ITEMS.PROMO_CODE}
            icon={<PercentageMarkIcon />}
            text={t.get('general.menu.promo_code_manager.promo_codes')}
            onClick={onPromoCodeClick}
            testId="add-promo-menu-item"
          />
        </S.Item>
        <S.Item>
          <MenuItem
            itemId={MENU_ITEMS.MY_ORDERS}
            icon={<HistoryIcon />}
            text={t.get('general.menu.my_orders')}
            location={{ pathname: MY_ORDERS_URL }}
            tag={StorageManager.getWithDefaultValue(ACTIVE_ORDERS_COUNT_KEY, 0)}
            testId="my-orders-menu-item"
          />
        </S.Item>
        {experimentManager.isEnabled('referral') && (
          <S.Item>
            <MenuItem
              itemId={MENU_ITEMS.REFERRAL}
              icon={<ReferralIcon />}
              text={t.get('referral.title', { v1: getReferralPrice() })}
              location={{ pathname: REFERRAL }}
              testId="referral-menu-item"
            />
          </S.Item>
        )}
        <S.Item>
          <MenuItem
            itemId={MENU_ITEMS.HELP_CENTER}
            icon={<QuestionMarkIcon />}
            text={t.get('general.menu.help_center')}
            onClick={handleHelpCenterClick}
            testId="help-center-menu-item"
          />
        </S.Item>
        <S.Item>
          <MenuItem
            itemId={MENU_ITEMS.CHAT_WITH_US}
            icon={<ChatIcon />}
            text={t.get('general.menu.chat_with_us')}
            onClick={handleTalkToUsClicked}
            testId="chat-menu-item"
          />
        </S.Item>
      </S.Section>
    </S.Container>
  )
}
